import type { TokenStore } from "@clubcore/api";

const KEY = "clubcore.token";

/**
 * The browser's token store. localStorage keeps staff signed in across tabs and iPad restarts.
 * Trade-off: script on the page can read it, so the app ships with no third-party scripts and
 * the server should send a strict Content-Security-Policy (see docs/web.md).
 * If storage is blocked the token lives in memory and the user signs in again on reload.
 */
export class BrowserTokenStore implements TokenStore {
  private memory: string | null = null;

  get(): string | null {
    try {
      return localStorage.getItem(KEY) ?? this.memory;
    } catch {
      return this.memory;
    }
  }

  set(token: string): void {
    this.memory = token;
    try {
      localStorage.setItem(KEY, token);
    } catch {
      /* memory copy is enough for this visit */
    }
  }

  clear(): void {
    this.memory = null;
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* nothing stored */
    }
  }
}
